
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`styled`}</inlineCode></h3>
    <p>{`This is the default export.
This is a low-level factory we use to create the `}<inlineCode parentName="p">{`styled.tagname`}</inlineCode>{` helper methods.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">component</Code> / <Code mdxType="Code">tagname</Code>
    </Column>
    <Column mdxType="Column">
      Either a valid react component or a tagname like <Code mdxType="Code">'div'</Code>.
    </Column>
  </Row>
    </Table>
    <p>{`Returns a function that accepts a tagged template literal and turns it into a `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// import styled from 'styled-components'

const Button = styled.button\`
  background: palevioletred;
  border-radius: 3px;
  border: none;
  color: white;
\`

const TomatoButton = styled(Button)\`
  background: tomato;
\`

render(
  <>
    <Button>I'm purple.</Button>
    <br />
    <TomatoButton>I'm red.</TomatoButton>
  </>
)
`}</code></pre>
    <p>{`You can see this method being introduced in the `}<a parentName="p" {...{
        "href": "/docs/basics#getting-started"
      }}>{`Getting started`}</a>{` section.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;